import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	versionDefaultValueLabelNew: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.versions.single.version-default-value-label-new',
		defaultMessage: 'Default version',
		description:
			'Label above drop down select to choose the default value for a version picker custom field',
	},
	versionPlaceholder: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.versions.single.version-placeholder',
		defaultMessage: 'Choose a version',
		description:
			'Placeholder content within a drop down select instructing users to choose the default value for a version picker custom field',
	},
	versionDefaultValueDisabledTooltip: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.versions.single.version-default-value-disabled-tooltip',
		defaultMessage: 'You can’t change this field’s default version',
		description:
			'Tooltip shown when the version picker field is disabled and the default value cannot be edited',
	},
});
